<script lang="ts">
  import type { StorageReference } from "firebase/storage"

  // svelte-ignore unused-export-let
  export let target: StorageReference
</script>
